/* ── ExceptionalFire — Fireplace Buying Guide, 2 tryby (2026-07-09) ────────────
   Tryb A „Find my fireplace": quiz dopasowania modelu (placement → vent → room →
     fuel → styl) → top-3 z katalogu EF_FP_GUIDE.
   Tryb B „Configure this one": pytania o SYTUACJĘ klienta generowane dynamicznie
     z opcji bieżącego produktu (EF_CFG_DATA[handle] + natywne fuel/ignition),
     mapowane na karty konfiguratora → podsumowanie „Your build" → Apply all
     (fizycznie klika karty). Działa dla każdego przyszłego modelu bez zmian.
   UI: modal ef-gq__* współdzielony z gas logs.
   Dane: window.EF_FP_GUIDE.catalog, window.EF_FP_GUIDE_PRODUCT, window.EF_CFG_DATA. */
(function () {
  var btn = document.getElementById('efOfGuideBtn');
  var modal = document.getElementById('efOfGuideModal');
  if (!btn || !modal) return;
  var bodyEl = document.getElementById('efGuideBody');
  var progEl = document.getElementById('efGuideProgress');
  var backEl = document.getElementById('efGuideBack');
  var CAT = (window.EF_FP_GUIDE && window.EF_FP_GUIDE.catalog) || [];
  var CUR = window.EF_FP_GUIDE_PRODUCT || { handle: '', title: '' };

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(n) { return '$' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function groupData() { return (window.EF_CFG_DATA && window.EF_CFG_DATA[CUR.handle]) || {}; }
  function hasCards(group) {
    var det = document.getElementById('efOfCd_' + group);
    return det && det.querySelectorAll('.ef-of__cd-opt').length > 0;
  }
  function findCard(group, re) {
    var det = document.getElementById('efOfCd_' + group);
    if (!det) return null;
    var hit = null;
    det.querySelectorAll('.ef-of__cd-opt').forEach(function (c) {
      if (hit || c.classList.contains('ef-of__cd-opt--unavail')) return;
      if (re.test((c.dataset.label || '') + ' ' + (c.dataset.rawLabel || ''))) hit = c;
    });
    return hit;
  }
  function cleanLbl(l) { return String(l || '').replace(/\s*\([A-Z0-9\-\/ ]+\)\s*$/, ''); }

  /* ═══ TRYB A — dopasowanie modelu (jak dotychczas) ═══ */
  var MATCH_STEPS = [
    { key: 'placement', q: 'Where is this fireplace going?', help: 'This decides the type of unit you need.',
      opts: [
        { label: 'A new wall, remodel, or addition', sub: 'Built-in firebox framed into the wall', val: 'wall' },
        { label: 'A wall between two rooms', sub: 'See-through — one fire, both sides', val: 'divider' },
        { label: 'Inside an existing wood fireplace', sub: 'That needs an insert — see note at the end', val: 'insert' }
      ] },
    { key: 'vent', q: 'Can you run a vent to the outside?', help: 'Through an exterior wall or up through the roof. Direct vent is sealed — it breathes outdoor air only.',
      opts: [
        { label: 'Yes — wall or roof is reachable', sub: 'Direct vent: the safe default', val: 'dv' },
        { label: 'No — interior wall, no vent path', sub: 'Vent-free: no chimney needed (check local code)', val: 'vf' },
        { label: 'Not sure', sub: 'We’ll assume direct vent — most homes qualify', val: 'dv' }
      ] },
    { key: 'room', q: 'How big is the room?', help: 'Sizing the BTUs to the room keeps it comfortable instead of sweltering.',
      opts: [
        { label: 'Cozy — up to ~300 sq ft', sub: 'Bedroom, office, den', val: 'small' },
        { label: 'Medium — 300–500 sq ft', sub: 'Living room, family room', val: 'medium' },
        { label: 'Large / open plan — 500+ sq ft', sub: 'Great room, open kitchen-living', val: 'large' },
        { label: 'Ambience first, heat second', sub: 'Any size works', val: 'any' }
      ] },
    { key: 'fuel', q: 'Natural gas or propane?', help: 'Every model comes in both — this just pre-fills your build.',
      opts: [
        { label: 'Natural Gas', sub: 'Connected to the home gas line', val: 'Natural Gas' },
        { label: 'Propane (LP)', sub: 'Tank supply', val: 'Propane' },
        { label: 'Not sure yet', sub: 'We’ll default to natural gas', val: 'Natural Gas' }
      ] },
    { key: 'style', q: 'What look are you after?', help: 'Traditional shows logs and flame; linear is a wide modern ribbon of fire over glass.',
      opts: [
        { label: 'Traditional', sub: 'Logs, brick interior, classic hearth', val: 'traditional' },
        { label: 'Modern linear', sub: 'Wide, low flame over crushed glass', val: 'linear' },
        { label: 'Show me both', sub: 'No preference', val: 'any' }
      ] }
  ];
  var BTU_BAND = { small: [0, 26000], medium: [26000, 38000], large: [38000, 99000] };

  /* ═══ TRYB B — asystent opcji bieżącego produktu ═══
     Kroki budowane w open() z realnych grup produktu. Każda odpowiedź niesie
     "actions": [{group, re}] — karty do kliknięcia przy Apply. */
  function buildAssistSteps() {
    var G = groupData();
    var steps = [];

    if (hasCards('fuel')) {
      steps.push({ key: 'a_fuel', q: 'Which gas do you have?', help: 'Check your utility bill or tank — every option below comes in both.',
        opts: [
          { label: 'Natural Gas', sub: 'Home gas line', actions: [{ group: 'fuel', re: /natural/i }], sum: ['Fuel', 'Natural Gas', 0] },
          { label: 'Propane (LP)', sub: 'Tank supply', actions: [{ group: 'fuel', re: /propane|lp\b/i }], sum: ['Fuel', 'Propane', 0] }
        ] });
    }

    /* Sterowanie → remote + ZAPŁON naraz (klient nie musi znać słowa millivolt). */
    if (hasCards('ignition')) {
      var opts = [
        { label: 'Simple — switch it on at the unit', sub: 'No extras. Works with zero electricity',
          actions: [{ group: 'ignition', re: /millivolt/i }, { group: 'remote', re: /^none$/i }], sum: ['Control', 'At the fireplace (millivolt)', 0] },
        { label: 'A wall switch, like a light', sub: 'Flip the fire on/off from the wall',
          actions: [{ group: 'ignition', re: /millivolt/i }, { group: 'remote', re: /wall switch/i }], sum: null },
        { label: 'Hold a temperature automatically', sub: 'Wall thermostat cycles the fire for you',
          actions: [{ group: 'ignition', re: /millivolt/i }, { group: 'remote', re: /wireless wall thermostat/i }], sum: null },
        { label: 'Handheld remote from the couch', sub: 'On/off in your hand',
          actions: [{ group: 'ignition', re: /millivolt/i }, { group: 'remote', re: /battery on\/off remote|on\/off remote \(frbc/i }], sum: null },
        { label: 'Remote that also holds room temp', sub: 'Thermostat built into the remote',
          actions: [{ group: 'ignition', re: /millivolt/i }, { group: 'remote', re: /thermostat remote/i }], sum: null },
        { label: 'Max gas savings — no standing pilot', sub: 'Electronic ignition lights only when needed',
          actions: [{ group: 'ignition', re: /electronic|ipi/i }, { group: 'remote', re: /^none$/i }], sum: ['Control', 'Electronic ignition (IPI)', 0] }
      ];
      /* Produkty bez grupy remote (np. Boulevard DV — pilot w zestawie): zostaw tylko sensowne. */
      if (!G.remote) opts = [
        { label: 'Millivolt — works in power outages', sub: 'Standing pilot, no electricity needed', actions: [{ group: 'ignition', re: /millivolt/i }], sum: ['Ignition', 'Millivolt', 0] },
        { label: 'Electronic — saves gas between fires', sub: 'No standing pilot, battery backup', actions: [{ group: 'ignition', re: /electronic|ipi/i }], sum: ['Ignition', 'Electronic (IPI)', 0] }
      ];
      steps.push({ key: 'a_control', q: 'How do you want to control the fire?', help: 'We’ll pick the right ignition and control hardware together.', opts: opts });
    }

    if (G.vent_kit) {
      steps.push({ key: 'a_vent', q: 'How will the vent run to the outside?', help: 'Direct vent needs a pipe out an exterior wall or up through the roof — we’ll add the matching kit.',
        opts: [
          { label: 'Straight up through the roof', sub: 'Pipe, flashing & rain cap in one kit', actions: [{ group: 'vent_kit', re: /vertical/i }], sum: null },
          { label: 'Out the wall right behind it', sub: 'Shortest run (rear vent)', actions: [{ group: 'vent_kit', re: /rear/i }], sum: null },
          { label: 'Up first, then out a standard wall', sub: 'Wall up to ~7" thick', actions: [{ group: 'vent_kit', re: /top horizontal.*(5-7|5x8)|\(dvvk-4tsp|\(dvvk-5tp/i }], sum: null },
          { label: 'Up first, then out a thick wall', sub: 'Brick/thick wall 8–11"', actions: [{ group: 'vent_kit', re: /8-11/i }], sum: null },
          { label: 'My installer handles venting', sub: 'Skip the kit for now', actions: [{ group: 'vent_kit', re: /^none$/i }], sum: ['Vent kit', 'Sourced by installer', 0] }
        ].filter(function (o) { return o.actions[0].re.source === '^none$' || !!findCardLazy('vent_kit', o.actions[0].re); }) });
    }

    if (G.blower) {
      steps.push({ key: 'a_blower', q: 'Is heating the room a priority?', help: 'A blower pushes the warm air out instead of letting it rise off the glass.',
        opts: [
          { label: 'Yes — I want real heat', sub: 'Add the auto blower', actions: [{ group: 'blower', re: /blower/i }], sum: null },
          { label: 'Mostly ambience', sub: 'Radiant warmth is enough', actions: [{ group: 'blower', re: /^none$/i }], sum: ['Blower', 'None', 0] }
        ] });
    }

    if (G.heat_mgmt) {
      steps.push({ key: 'a_tv', q: 'Planning a TV or mantel above it?', help: 'Heat management redirects heat so electronics live safely closer to the opening.',
        opts: [
          { label: 'Yes — TV/mantel above', sub: 'Gravity kit: TV as low as 16" above', actions: [{ group: 'heat_mgmt', re: /gravity/i }], sum: null },
          { label: 'Yes, and send heat elsewhere', sub: 'Forced-air kit moves heat to another room', actions: [{ group: 'heat_mgmt', re: /forced/i }], sum: null },
          { label: 'No', sub: 'Standard heat distribution', actions: [{ group: 'heat_mgmt', re: /^none$/i }], sum: ['Heat management', 'Standard', 0] }
        ] });
    }

    /* Wnętrze: liner — opcje 1:1 z danych produktu (ceny widoczne). */
    if (G.liner && G.liner.length > 1) {
      steps.push({ key: 'a_liner', q: 'Pick the interior look', help: 'The liner is the back and side walls you see behind the flame.',
        opts: G.liner.map(function (o) {
          var isNone = /^none$/i.test(o.label);
          return { label: isNone ? cleanNoneLiner(o.desc) : cleanLbl(o.label), sub: (o.desc || '') + (o.price ? ' · +' + money(o.price) : ''),
            actions: [{ group: 'liner', re: new RegExp(escapeRe(o.label.slice(0, 24)), 'i') }], sum: null };
        }) });
    }

    return steps;
  }
  function cleanNoneLiner(desc) { return desc && /included/i.test(desc) ? 'Keep the included liner' : 'Keep the standard interior'; }
  function escapeRe(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  /* findCard zanim karty są w DOM? Karty renderują się przy populateAll (defer wcześniej) — przy otwarciu modalu już są. */
  function findCardLazy(group, re) { return findCard(group, re); }

  var mode = null; /* null → wybór trybu; 'match' | 'assist' */
  var STEPS = [];
  var answers = {}; var idx = 0;

  function open() {
    mode = null; idx = 0; answers = {}; STEPS = [];
    renderModeChoice();
    modal.hidden = false; document.documentElement.style.overflow = 'hidden';
  }
  function close() { modal.hidden = true; document.documentElement.style.overflow = ''; }

  function renderModeChoice() {
    renderProgress(-1, 1);
    if (backEl) backEl.hidden = true;
    var h = '<p class="ef-gq__step">Fireplace Guide</p>';
    h += '<h2 class="ef-gq__q">What can we help with?</h2>';
    h += '<div class="ef-gq__opts">';
    h += '<button type="button" class="ef-gq__opt" data-mode="assist">'
      + '<span class="ef-gq__opt-main">Help me choose the options on this fireplace</span>'
      + '<span class="ef-gq__opt-sub">Vent kit, ignition, blower, liner… — answer a few questions and we’ll set every step for you</span>'
      + '<span class="ef-gq__opt-arrow" aria-hidden="true">→</span></button>';
    h += '<button type="button" class="ef-gq__opt" data-mode="match">'
      + '<span class="ef-gq__opt-main">Is this the right fireplace for me?</span>'
      + '<span class="ef-gq__opt-sub">2-minute quiz — vent type, room size &amp; style → we recommend the best models</span>'
      + '<span class="ef-gq__opt-arrow" aria-hidden="true">→</span></button>';
    h += '</div>';
    bodyEl.innerHTML = h;
    bodyEl.querySelectorAll('[data-mode]').forEach(function (b) {
      b.addEventListener('click', function () {
        mode = b.dataset.mode;
        STEPS = mode === 'assist' ? buildAssistSteps() : MATCH_STEPS;
        idx = 0; answers = {};
        if (mode === 'assist' && !STEPS.length) { mode = 'match'; STEPS = MATCH_STEPS; }
        render();
      });
    });
  }

  function renderProgress(active, total) {
    if (!progEl) return;
    var h = '';
    for (var i = 0; i < total; i++) h += '<span class="ef-gq__dot' + (i <= active ? ' is-on' : '') + '"></span>';
    progEl.innerHTML = h;
  }

  function render() {
    if (idx >= STEPS.length) return mode === 'assist' ? renderAssistResult() : renderMatchResult();
    var step = STEPS[idx];
    renderProgress(idx, STEPS.length);
    if (backEl) backEl.hidden = false;
    var h = '<p class="ef-gq__step">Question ' + (idx + 1) + ' of ' + STEPS.length + '</p>';
    h += '<h2 class="ef-gq__q">' + esc(step.q) + '</h2>';
    h += '<p class="ef-gq__help">' + esc(step.help) + '</p>';
    h += '<div class="ef-gq__opts">';
    step.opts.forEach(function (o, i) {
      var sel = answers[step.key] && answers[step.key].label === o.label;
      h += '<button type="button" class="ef-gq__opt' + (sel ? ' is-sel' : '') + '" data-i="' + i + '">'
        + '<span class="ef-gq__opt-main">' + esc(o.label) + '</span>'
        + '<span class="ef-gq__opt-sub">' + esc(o.sub) + '</span>'
        + '<span class="ef-gq__opt-arrow" aria-hidden="true">→</span></button>';
    });
    h += '</div>';
    bodyEl.innerHTML = h;
    bodyEl.querySelectorAll('.ef-gq__opt').forEach(function (b) {
      b.addEventListener('click', function () { answers[step.key] = step.opts[+b.dataset.i]; idx++; render(); });
    });
  }

  /* ── Wynik trybu B: podsumowanie „Your build" + Apply all ── */
  function resolveSelections() {
    var picks = []; /* {group, card, kicker, title, price} */
    STEPS.forEach(function (step) {
      var a = answers[step.key];
      if (!a) return;
      (a.actions || []).forEach(function (act) {
        var card = findCard(act.group, act.re);
        if (card) {
          picks.push({ group: act.group, card: card, title: cleanLbl(card.dataset.label), price: parseInt(card.dataset.price || '0', 10) });
        } else if (a.sum) {
          picks.push({ group: act.group, card: null, title: a.sum[1], price: a.sum[2] || 0 });
        }
      });
    });
    return picks;
  }
  var GROUP_NAMES = { fuel: 'Fuel', ignition: 'Ignition', remote: 'Remote & Controls', vent_kit: 'Vent kit', blower: 'Blower', heat_mgmt: 'Heat management', liner: 'Interior liner', front: 'Front & trim', media: 'Burner media', logset: 'Log set', lighting: 'Accent lighting', screen: 'Barrier screen' };

  function renderAssistResult() {
    renderProgress(STEPS.length, STEPS.length);
    if (backEl) backEl.hidden = false;
    var picks = resolveSelections();
    var addon = 0;
    picks.forEach(function (p) { if (p.card && p.price > 0) addon += p.price; });

    var h = '<div class="ef-gq__result">';
    h += '<p class="ef-gq__step">Your build</p>';
    h += '<h2 class="ef-gq__q">Here’s your configuration</h2>';
    h += '<div class="ef-gq__rec">';
    picks.forEach(function (p) {
      h += '<div class="ef-gq__rec-row"><span class="ef-gq__rec-ic">'
        + '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2F7A4A" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg></span>'
        + '<span class="ef-gq__rec-body">'
        + '<span class="ef-gq__rec-kicker">' + esc(GROUP_NAMES[p.group] || p.group) + (p.price > 0 ? ' · +' + money(p.price) : '') + '</span>'
        + '<span class="ef-gq__rec-title">' + esc(p.title) + '</span>'
        + '</span></div>';
    });
    h += '</div>';
    if (addon > 0) h += '<p class="ef-gq__help" style="margin-top:10px;">Selected add-ons: <strong>+' + money(addon) + '</strong> on top of the fireplace. Anything you skip can be added later.</p>';
    h += '<p class="ef-gq__help">Style extras — log set, glass color, front &amp; lighting — are quick visual picks in the steps below.</p>';
    h += '<div class="ef-gq__actions">';
    h += '<button type="button" class="ef-gq__apply" id="efGuideApplyBuild">Apply all to my build</button>';
    h += '<button type="button" class="ef-gq__restart" id="efGuideRestart">Start over</button>';
    h += '</div></div>';
    bodyEl.innerHTML = h;

    var applyBtn = document.getElementById('efGuideApplyBuild');
    if (applyBtn) applyBtn.addEventListener('click', function () {
      close();
      var n = 0;
      picks.forEach(function (p) { if (p.card) { p.card.click(); n++; } });
      var form = document.getElementById('efOf');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      toast('✓ Applied ' + n + ' selections — review your build below.');
    });
    var restart = document.getElementById('efGuideRestart');
    if (restart) restart.addEventListener('click', open);
  }

  /* ── Wynik trybu A: rekomendacje modeli (jak dotychczas) ── */
  function recommend() {
    var vent = answers.vent ? answers.vent.val : 'dv';
    var placement = answers.placement ? answers.placement.val : 'wall';
    var style = answers.style ? answers.style.val : 'any';
    var room = answers.room ? answers.room.val : 'any';
    var pool = CAT.filter(function (p) {
      if (placement === 'insert') return p.install === 'insert' && p.vent === vent;
      if (p.install === 'insert') return false;
      if (placement === 'divider') return p.config === 'see-through';
      if (p.config === 'see-through') return false;
      return p.vent === vent;
    });
    if (placement === 'insert' && !pool.length) pool = CAT.filter(function (p) { return p.install === 'insert'; });
    if (placement !== 'divider' && style !== 'any') {
      var styled = pool.filter(function (p) { return p.style === style; });
      if (styled.length) pool = styled;
    }
    pool.forEach(function (p) {
      p._score = (p.pop || 5);
      if (room !== 'any') {
        var band = BTU_BAND[room];
        if (p.btu >= band[0] && p.btu < band[1]) p._score += 20;
        else if (Math.abs(p.btu - (band[0] + band[1]) / 2) < 12000) p._score += 8;
      }
      if (p.handle === CUR.handle) p._score += 3;
    });
    pool.sort(function (a, b) { return b._score - a._score; });
    return pool.slice(0, 3);
  }
  function whyFor(p) {
    var bits = [];
    bits.push(p.vent === 'vf' ? '99.9% efficient, no vent needed' : 'Sealed direct vent — safest indoor air');
    bits.push((p.btu / 1000) + 'k BTU · ' + p.width + '" wide');
    if (p.config === 'see-through') bits.push('finished on both sides');
    else bits.push(p.style === 'linear' ? 'modern linear flame' : 'classic log fire');
    return bits.join(' · ');
  }
  function renderMatchResult() {
    renderProgress(STEPS.length, STEPS.length);
    if (backEl) backEl.hidden = false;
    var placement = answers.placement ? answers.placement.val : 'wall';
    var vent = answers.vent ? answers.vent.val : 'dv';
    var fuel = answers.fuel ? answers.fuel.val : 'Natural Gas';
    var recs = recommend();

    var h = '<div class="ef-gq__result">';
    h += '<p class="ef-gq__step">Your perfect match</p>';
    h += '<h2 class="ef-gq__q">Here’s what we recommend</h2>';
    if (placement === 'insert') {
      h += '<p class="ef-gq__note ef-gq__note--ok">An existing wood fireplace takes a <strong>gas insert</strong> — the picks below drop into your firebox and vent up the existing chimney. '
        + 'Measure your firebox (front width, rear width, height, depth) and check it against each model’s minimum opening; '
        + 'or <a href="/pages/contact-us">send us the measurements</a> and a specialist will confirm the fit.</p>';
    }
    if (vent === 'vf') {
      h += '<p class="ef-gq__note">Vent-free heaters are <strong>not permitted in California</strong> and are restricted in some '
        + 'jurisdictions (e.g. Massachusetts) — please confirm with your local building authority. Room must provide 50 cu ft of air per 1,000 BTU/hr.</p>';
    }
    if (!recs.length) {
      h += '<p class="ef-gq__note">No exact match in this collection yet — <a href="/pages/contact-us">talk to a fireplace expert</a> and we’ll source it.</p>';
    } else {
      h += '<div class="ef-gq__rec">';
      recs.forEach(function (p, i) {
        var isCur = p.handle === CUR.handle;
        var badge = isCur ? 'You’re looking at it' : (i === 0 ? 'Best match' : 'Also fits');
        h += '<a class="ef-gq__rec-row" style="text-decoration:none;color:inherit;' + (isCur ? 'cursor:default;' : '') + '" href="' + (isCur ? 'javascript:void(0)' : '/products/' + esc(p.handle)) + '"'
          + (isCur ? ' data-guide-close-cur="1"' : '') + '>'
          + '<span class="ef-gq__rec-ic">' + (isCur
            ? '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#2F7A4A" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>'
            : '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#8A6A43" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2.5c1.5 3 4.5 4.5 4.5 8.5a4.5 4.5 0 0 1-9 0c0-1.6.7-2.7 1.5-3.6.2 1 .8 1.8 1.7 2.1-.1-2.6.6-5 1.3-7z"/></svg>') + '</span>'
          + '<span class="ef-gq__rec-body">'
          + '<span class="ef-gq__rec-kicker">' + esc(badge) + ' · from ' + money(p.price) + '</span>'
          + '<span class="ef-gq__rec-title">' + esc(p.title) + '</span>'
          + '<span class="ef-gq__rec-desc">' + esc(whyFor(p)) + '</span>'
          + '</span></a>';
      });
      h += '</div>';
    }
    h += '<div class="ef-gq__actions">';
    var curRec = recs.filter(function (p) { return p.handle === CUR.handle; })[0];
    if (curRec) {
      h += '<button type="button" class="ef-gq__apply" id="efGuideGoAssist">Great — now help me pick the options</button>';
    }
    h += '<button type="button" class="ef-gq__restart" id="efGuideRestart">Start over</button>';
    h += '</div></div>';
    bodyEl.innerHTML = h;

    var goAssist = document.getElementById('efGuideGoAssist');
    if (goAssist) goAssist.addEventListener('click', function () {
      var fuelAns = answers.fuel;
      mode = 'assist'; STEPS = buildAssistSteps(); idx = 0; answers = {};
      /* przenieś odpowiedź o paliwie z trybu match */
      if (fuelAns && STEPS.length && STEPS[0].key === 'a_fuel') {
        var target = /propane/i.test(fuelAns.val) ? /propane/i : /natural/i;
        var pre = STEPS[0].opts.filter(function (o) { return target.test(o.label); })[0];
        if (pre) { answers.a_fuel = pre; idx = 1; }
      }
      render();
    });
    var restart = document.getElementById('efGuideRestart');
    if (restart) restart.addEventListener('click', open);
    bodyEl.querySelectorAll('[data-guide-close-cur]').forEach(function (a) {
      a.addEventListener('click', function (e) { e.preventDefault(); close(); });
    });
  }

  var toastWrap = null;
  function toast(msg) {
    if (!toastWrap) { toastWrap = document.createElement('div'); toastWrap.className = 'ef-gq-toasts'; document.body.appendChild(toastWrap); }
    var t = document.createElement('div'); t.className = 'ef-gq-toast'; t.textContent = msg;
    toastWrap.appendChild(t);
    requestAnimationFrame(function () { t.classList.add('is-in'); });
    setTimeout(function () { t.classList.remove('is-in'); setTimeout(function () { t.remove(); }, 300); }, 4200);
  }

  btn.addEventListener('click', open);
  document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-fireplace-quiz]')) { e.preventDefault(); open(); } });
  window.efOpenFireplaceGuide = open;
  modal.addEventListener('click', function (e) { if (e.target.closest('[data-guide-close]')) close(); });
  if (backEl) backEl.addEventListener('click', function () {
    if (idx > 0) { idx--; render(); }
    else if (mode) { renderModeChoice(); mode = null; }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });
})();
